<template>
	<div class="webContent flex">
		<div class="model">
			<div class="area df hao jcb">
				<div class="name"><em>下载/播放专区</em>{{name}}</div>
				<div class="upload" @click="toUpload" v-if="$h5Power=='teacher'">上传</div>
			</div>
			<div class="search df hao">
				<input type="text" puc class="flex" placeholder="本版块搜索" />
				<div class="btn"></div>
			</div>
			<div class="scroll">
				<div class="list">
					<div class="li" v-for="(v,i) in list" @click="toDetail(v)">
						<div class="title"><i v-if="v.tx!=''" :class="v.tx"></i>{{v.title}}</div>
						<div class="tool df">
							<div class="flex">{{v.downloadCount}}次下载<em>{{v.collectCount}}人收藏</em></div>
							<div><b>{{v.createUser}}</b>{{v.createDate}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'material_list_page',
		data () {
			return {
				name: '#话题',
				list: [
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'img',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书911启动说明书911启动说明书911启动说明书',
						tx: 'video',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'img',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'video',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
					{
						title: '911启动说明书',
						tx: 'pdf',
						createDate: '2020-11-15',
						createUser: '李玉雨',
						downloadCount: 133,
						collectCount: 15,
					},
				],
			}
		},
		methods: {
			toUpload(){
				this.$router.replace('/material/upload');
			},
			toDetail(){
				this.$router.replace('/material/detail');
			},
		},
	}
</script>

<style scoped>
	@import './list'
</style>



// WEBPACK FOOTER //
// src/app/pages/material/list/list.vue